import { render, staticRenderFns } from "./BannerSettings.vue?vue&type=template&id=607336b0&scoped=true"
import script from "./BannerSettings.vue?vue&type=script&lang=js"
export * from "./BannerSettings.vue?vue&type=script&lang=js"
import style0 from "./BannerSettings.vue?vue&type=style&index=0&id=607336b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607336b0",
  null
  
)

export default component.exports